import {useQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'
import type {AgentTaskAppPayload} from '@github-ui/agent-sessions/types/agent-task-app-payload'

/**
 * Fetches the task payload including permissions, pull request, sessions,
 * current user, and session owners from the task endpoint.
 */
export function useTaskPermissions(owner: string, repo: string, taskId: string) {
  return useQuery<AgentTaskAppPayload>({
    queryKey: ['task-permissions', owner, repo, taskId],
    queryFn: async () => {
      const resp = await verifiedFetchJSON(`/${owner}/${repo}/tasks/${taskId}.json`)
      if (!resp.ok) {
        throw new Error(`Failed to fetch task permissions: ${resp.status} ${resp.statusText}`)
      }
      const data = await resp.json()
      const backendPayload = data?.payload?.repoTaskByIdRoute
      if (!backendPayload || typeof backendPayload !== 'object') {
        throw new Error('Unexpected response shape: missing payload.repoTaskByIdRoute')
      }
      return backendPayload as AgentTaskAppPayload
    },
    enabled: !!owner && !!repo && !!taskId,
    staleTime: Infinity,
  })
}
